import BigNumber from 'bignumber.js';
import { isDefined } from '~/types/typeGuards';

export const cleanValue = (value: string, onlyPositive = false): string => {
  if (onlyPositive) {
    return (new RegExp(/^\d*[.,]?(\d*)?/).exec(value)?.[0] ?? '').replace(',', '.');
  }
  return (new RegExp(/^[-]?\d*[.,]?(\d*)?/).exec(value)?.[0] ?? '').replace(',', '.');
};

export const parseValueForInput = (value: string | undefined): string => {
  if (value === undefined) {
    return '0';
  }
  return value.replace('.', ',');
};

export const parseValue = (value: string): number => {
  const cleaned = cleanValue(value);
  const withoutTrailingComma = cleaned.replace(/[.,]$/, '');
  const withDot = withoutTrailingComma.replace(',', '.');
  const isNegative = withDot.startsWith('-');
  if (isNegative) {
    const val = parseFloat(withDot.slice(1));
    return isNaN(val) ? val : -val;
  }
  return parseFloat(withDot);
};

export const parseOptionalValue = (value: string): number | null => {
  const parsed = parseValue(value);
  if (isNaN(parsed)) {
    return null;
  }
  return parsed;
};

export const isPositive = (value: string): boolean => {
  return parseValue(value) > 0;
};

export const limitDecimalPlaces = (value: string, maxDecimalPlaces?: number): string => {
  if (!isDefined(maxDecimalPlaces)) {
    return value;
  }
  const parsed = BigNumber(value);
  if (parsed.isNaN() || (parsed.decimalPlaces() === 0 && value.endsWith('.'))) {
    // necessary to support empty strings and trailing dot e.g. "123."
    return value;
  }

  return parsed.decimalPlaces(maxDecimalPlaces, BigNumber.ROUND_DOWN).toString();
};
